import cx from 'classnames'
import Toggle from 'components/Toggle'
import styles from './style.styl'

const OnlineToggle = ({ className, ...props }) => (
  <Toggle
    className={cx(styles.OnlineToggle, className)}
    icons={{
      checked: <span>Online</span>,
      unchecked: <span>Offline</span>,
    }}
    {...props}
  />
)

OnlineToggle.displayName = 'OnlineToggle'

export default OnlineToggle



// WEBPACK FOOTER //
// ./src/scripts/components/shared/OnlineToggle/index.js